<!--
    Program: EmToken.vue
    Author: SDL
    Description: 
    Created: 2020.03.20
-->

<template>
    <div>
        <div class="sub_tit mt25">KRC Map Info</div>
        <!-- breadcrumbs -->
        <!-- srchTop_wrap -->
        <div class="srchTop_wrap">
            <article class="srch_basic">
                <div class="srch_grup">
                    <ul class="w49">
                        <li class="tit_150">Subsidiary</li>
                        <li data-input-type="select" class="w100-150">
                            <select
                                class="slt_white w100"
                                ref="selectCompany"
                                v-model="selectedCompany"
                            >
                                <option
                                    v-for="item in availableCompanyList"
                                    :key="item.CODE_ID"
                                    :value="item.CODE_ID"
                                >{{item.CODE_NAME}}</option>
                            </select>
                        </li>
                    </ul>
                    <ul class="w49">
                        <li class="tit_150">ASC</li>
                        <li data-input-type="select" class="w100-150">
                            <span class="clearable">
                                <input
                                    type="text"
                                    class="text_input w100"
                                    maxlength="20"
                                    placeholder
                                    v-model="asc"
                                    v-clearable
                                />
                            </span>
                        </li>
                    </ul>
                </div>
                <div class="srch_grupR">
                    <span class="btn">
                        <a href="javascript:" class="btn_srch" @click="onSearchClick">Search</a>
                    </span>
                </div>
            </article>
        </div>
        <!-- Grid -->
        <div class="grid_wrap">
            <!-- Grid Count-->
            <div class="grid_total">
                Total Count
                <em>{{ resultCount | numberFormat }}</em>
            </div>
            <!-- Grid -->
            <div id="grid">
                <toast-grid
                    gridId="gridKrcMap"
                    ref="gridKrcMap"
                    :key="gridKey"
                    :data="gridData"
                    :columns="gridColumns"
                    :options="gridOptions"
                    :pageOptions="gridPageOptions"
                    :theme="gridTheme"
                    :isTotalCount="false"
                    v-bind:click="onGridCellClick"
                />
            </div>

            <div class="paginate">
                <sdl-pagination
                    :current-page="currentPage"
                    :total-rows="resultCount"
                    :per-page="perPage"
                    @change="onGoToPage"
                    align="center"
                />
            </div>
        </div>
        <!-- Role tit -->
    </div>
</template>

<script>
import axios from 'axios';
import qs from 'query-string';
import { SDLUtil, StringUtil, DateUtil } from '@/utils';

import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';

import Pagination from '@/components/common/control/pagination/Pagination';
import ToastGrid from '~c/ToastGrid';

import { CellHtmlRenderer } from '~c/GridCustomRenderer';

export default {
    name: 'emToken',
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
        'toast-grid': ToastGrid,
        'sdl-pagination': Pagination,
    },
    props: {
        companyList: {
            type: Array,
            required: true,
        },
    },
    computed: {},
    data() {
        return {
            pageTitle: '',

            availableCompanyList: [],

            selectedCompany: '',

            asc: '',

            resultCount: 0,

            currentPage: 1,
            perPage: parseInt(localStorage.getItem('listRows') || 10),

            gridKey: 0,
            gridData: [],

            gridColumns: [
                {
                    header: 'Subsidiary',
                    name: 'COMPANY_NM',
                    width: 120,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'ASC CODE',
                    name: 'ASC_CODE',
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Register',
                    name: 'REGISTER_HTML',
                    width: 160,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                    renderer: CellHtmlRenderer,
                },
            ],
            gridOptions: {
                scrollX: false,
                scrollY: false,
            },
            gridPageOptions: null,
            gridTheme: {
                name: 'skpTheme', // required
                value: {
                    // required
                    row: {
                        hover: {
                            background: '#FBFBFC',
                        },
                    },
                    // cell: {
                    //     normal: {
                    //         background: '#00ff00',
                    //         border: '#e0e0e0'
                    //     },
                    //     head: {
                    //         background: '#ff0000',
                    //         border: '#ffff00'
                    //     },
                    // },
                },
            },
        };
    },
    created() {
        console.log('Component: KRCMap Asc created. ');
    },
    mounted() {
        console.log('Component: KRCMap Asc mounted.');
        this.init();
    },
    methods: {
        async init() {
            // const data = await this.fetchInitData();
            // if (data == null) return;
            // this.setCountryList(this.countryList);
            this.setCompanyList(this.companyList);
        },

        setCompanyList(list) {
            // list = list.map(item => {
            //     return {
            //         CODE_ID: item.COMPANY,
            //         CODE_NAME: item.COMPANY_NM,
            //     };
            // });

            list = list.filter(item => item.CODE_ID !== 'ALL');

            list.unshift({
                CODE_ID: '',
                CODE_NAME: 'Select',
            });

            this.availableCompanyList = list;

            this.selectedCompany = '';
        },

        onSearchClick() {
            this.doSearch(1);
        },

        async doSearch(pageNo) {
            if (!this.selectedCompany) {
                SDLUtil.alert({
                    title: 'Invalid input',
                    msg: 'Please select Company',
                });
                return false;
            }
            const params = this.prepSearchParams(pageNo);
            SDLUtil.showLoadingBar(true);
            const data = await this.fetchSearchResult(params);
            this.setSearchResult(data);
            this.currentPage = pageNo;
            // this.lastSearchParams = params;
            SDLUtil.showLoadingBar(false);
        },

        prepSearchParams(pageNo) {
            if (!pageNo) pageNo = 1;

            const params = {
                page: pageNo,
                asc_code: this.asc,
                icompany: this.selectedCompany,
            };

            console.log('search params', params);
            return params;
        },

        fetchSearchResult(formData) {
            return SDLUtil.postForm('/basis/anysvcmobile/KRCMapMgmt/KRCMapMgmtASCSearch.skp', formData);
        },

        setSearchResult(data) {
            // this.resultCount = data.rows.length;
            this.resultCount = data.count;
            this.gridData = data.rows.map(row => {
                row.REGISTER_HTML = `<a href="javascript:" class="btn_sm_white">Add</a>`;
                return row;
            });
            // this.gridData = data.rows;
            this.gridKey += 1;
        },

        onGoToPage(pageNo) {
            // this.lastSearchParams.page = pageNo;
            this.doSearch(pageNo);
        },

        onGridCellClick(event, rowData) {
            console.log(event);
            if (typeof event.rowKey === 'undefined') return;
            const row = rowData[event.rowKey];
            // console.log('event rowKey', event.rowKey);
            // console.log('event columnName', event.columnName);
            // console.log('event rowData', rowData);
            console.log('event row', rowData[event.rowKey]);
            if (event.columnName === 'REGISTER_HTML') {
                this.insertKrcMap(row.COMPANY, row.ASC_CODE);
            }
        },

        insertKrcMap(company, ascCode) {
            SDLUtil.showLoadingBar(true);
            const formData = {
                icompany: company,
                asc_code: ascCode,
            };
            return SDLUtil.postForm('/basis/anysvcmobile/KRCMapMgmt/InsertKRCMap.skp', formData)
                .then(data => {
                    SDLUtil.showLoadingBar(false);
                    SDLUtil.alert({
                        title: 'Success!',
                        msg: `Insertion complete!<br>(If there was an existing record, it has been overwritten)`,
                        onOkEvt: () => {
                            this.doSearch(1);
                        },
                    });
                })
                .catch(err => {
                    console.log('err', err);
                    SDLUtil.showLoadingBar(false);
                    if (err.data.error.code === 'HHP_INVALID_REQUEST') {
                        const msg = err.data.error.message;
                        SDLUtil.alert({
                            title: 'Invalid!',
                            msg,
                            onOkEvt: () => {},
                        });
                    }
                });
        },
    },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/KRCMapMgmt/KRCMapMgmtAsc.vue